import { render, staticRenderFns } from "./hina-checkbox-group.vue?vue&type=template&id=2748e10c&scoped=true"
import script from "./hina-checkbox-group.vue?vue&type=script&lang=ts"
export * from "./hina-checkbox-group.vue?vue&type=script&lang=ts"
import style0 from "./hina-checkbox-group.vue?vue&type=style&index=0&id=2748e10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748e10c",
  null
  
)

export default component.exports